async function checkBrowserPermissions() {
  const navigator = (window as any).navigator;

  const getUserMediaAggregator = (
    navigator.mediaDevices.getUserMedia || navigator.mediaDevices.webkitGetUserMedia
  ).bind(navigator.mediaDevices);

  try {
    const micStream = await getUserMediaAggregator({ audio: true });

    micStream.stop();

    return true;
  } catch (error) {
    return false;
  }
}

async function checkIOSPermissions() {
  const native = (window as any).Native;

  const permissionCheckPromise = new Promise((resolve, reject) => {
    native.checkOrRequestAudioRecordPermission((status: number) => {
      switch (status) {
        case 1:
          resolve();
          break;
        default:
          reject();
      }
    });
  });

  try {
    await permissionCheckPromise;

    return true;
  } catch (error) {
    return false;
  }
}

export async function micPermissionInspector() {
  let permissionStatus = false;

  const native = (window as any).Native;

  if (native) {
    permissionStatus = await checkIOSPermissions();
  } else {
    permissionStatus = await checkBrowserPermissions();
  }

  return permissionStatus;
}
